import i18n from '../../../Utils/i18n';
import { ReportFormat, ReportType } from '../../../Utils/Constants';
import AppConstants from '../../../AppConstants';

export function getReportTypeInfo(reportType) {
  if (reportType === null) {
    return {};
  }
  switch (reportType) {
    case ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.virtualEventExecutiveSummary.title'),
        description: i18n.t('generateReport.reportTypeCards.virtualEventExecutiveSummary.description'),
        iconClass: 'reportIcon virtual-events-executive-summary-icon ',
        isNewReport: true,
        isVeryNewReport: true
      };

    case ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.virtualEventRegistrationReport.title'),
        description: i18n.t('generateReport.reportTypeCards.virtualEventRegistrationReport.description'),
        iconClass: 'reportIcon virtual-events-registration-report-icon',
        isNewReport: true,
        isVeryNewReport: true
      };

    case ReportType.SESSIONS_OVERVIEW_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.sessionOverview.title'),
        description: i18n.t('generateReport.reportTypeCards.sessionOverview.description'),
        iconClass: 'reportIcon overview-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_ATTENDEE_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.attendee.title'),
        description: i18n.t('generateReport.reportTypeCards.attendee.description'),
        iconClass: 'reportIcon attendee-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_PERFORMANCE_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.performance.title'),
        description: i18n.t('generateReport.reportTypeCards.performance.description'),
        iconClass: 'reportIcon performance-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_QANDA_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.qAndA.title'),
        description: i18n.t('generateReport.reportTypeCards.qAndA.description'),
        iconClass: 'reportIcon qa-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_SURVEY_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.survey.title'),
        description: i18n.t('generateReport.reportTypeCards.survey.description'),
        iconClass: 'reportIcon survey-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_REGISTRATION_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.registration.title'),
        description: i18n.t('generateReport.reportTypeCards.registration.description'),
        iconClass: 'reportIcon registration-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_RECORDING_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.recording.title'),
        description: i18n.t('generateReport.reportTypeCards.recording.description'),
        iconClass: 'reportIcon recording-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.SESSIONS_ATTENDANCE_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.multiSessionAttendee.title'),
        description: i18n.t('generateReport.reportTypeCards.multiSessionAttendee.description'),
        iconClass: 'reportIcon sessions-attendance-icon',
        isNewReport: true,
        isVeryNewReport: false
      };

    case ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.engagement.title'),
        description: i18n.t('generateReport.reportTypeCards.engagement.description'),
        iconClass: 'reportIcon engagement-icon',
        isNewReport: true,
        isVeryNewReport: false
      };

    default:
      console.warn('Invalid Report Type selected');
      return {};
  }
}

export function getReportFormatInfo(reportFormat) {
  if (reportFormat === null) {
    return {};
  }
  switch (reportFormat) {
    case ReportFormat.PDF:
      return {
        title: i18n.t('report.format.pdf')
      };

    case ReportFormat.XLSX:
      return {
        title: i18n.t('report.format.excel')
      };

    case ReportFormat.CSV:
      return {
        title: i18n.t('report.format.csv')
      };

    default:
      console.warn('Invalid Report Format selected');
      return {};
  }
}

export class WizardStepID {
  static get SELECT_REPORT_TYPE() {
    return 'SELECT_REPORT_TYPE';
  }

  static get FILTER_RECORDS() {
    return 'FILTER_RECORDS';
  }

  static get SELECT_REPORT_FORMAT() {
    return 'SELECT_REPORT_FORMAT';
  }
}

export function validateSelection(reportType, combinedStats = {}) {
  let result = {
    error: null,
    moreInfoTooltip: null,
    subMessage: null
  };
  if (reportType === null) {
    return result;
  }
  const {
    filteredSelectedTotalRegistrants,
    filteredSelectedTotalEngagementCount,
    filteredTotalRegistrants,
    filteredTotalEngagementCount,
    numberOfSelectedSessions,
    numberOfSelectedWebinars,
    numberOfSelectedRecordings,
    selectedVirtualEventTitle
  } = combinedStats;

  switch (reportType) {
    case ReportType.SESSIONS_OVERVIEW_REPORT:
      if (numberOfSelectedSessions === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      }
      if (numberOfSelectedSessions > AppConstants.REPORT_MAXIMUM_SESSIONS_COUNT) {
        result.error = i18n.t('generateReport.warning.moreSessions');
      }

      break;
    case ReportType.WEBINAR_ATTENDEE_REPORT:
      if (numberOfSelectedSessions === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedSessions > 1) {
        result.error = `${i18n.t('generateReport.warning.oneWebinar')} ${i18n.t('generateReport.info.newReportAlert', {
          newReportAlert: i18n.t('generateReport.reportType.attendeeV2')
        })}`;
      }
      break;
    case ReportType.WEBINAR_PERFORMANCE_REPORT:
      if (numberOfSelectedSessions === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedSessions > 1) {
        result.error = `${i18n.t('generateReport.warning.oneWebinar')} ${i18n.t('generateReport.info.newReportAlert', {
          newReportAlert: i18n.t('generateReport.reportType.overview')
        })}`;
      }
      break;
    case ReportType.WEBINAR_QANDA_REPORT:
    case ReportType.WEBINAR_SURVEY_REPORT:
      if (numberOfSelectedSessions === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedSessions > 1) {
        result.error = `${i18n.t('generateReport.warning.oneWebinar')} ${i18n.t('generateReport.info.newReportAlert', {
          newReportAlert: i18n.t('generateReport.reportType.qandaV2')
        })}`;
      }
      break;

    case ReportType.SESSIONS_ATTENDANCE_REPORT:
      if (numberOfSelectedSessions === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedSessions > AppConstants.REPORT_MAXIMUM_SESSIONS_COUNT) {
        result.error = i18n.t('generateReport.warning.moreSessions');
      } else if (filteredSelectedTotalRegistrants > AppConstants.REPORT_SHOW_INLINE_WARNING_COUNT) {
        const countMessage = i18n.t('generateReport.info.registrantCountMessage', {
          selectedRegistrantCount: filteredSelectedTotalRegistrants,
          maxRegistrantCount: AppConstants.REPORT_MAXIMUM_REGISTRANTS_COUNT,
          totalRegistrantCount: filteredTotalRegistrants
        });
        if (filteredSelectedTotalRegistrants > AppConstants.REPORT_MAXIMUM_REGISTRANTS_COUNT) {
          result.error = countMessage;
        } else {
          result.subMessage = countMessage;
        }
      }
      break;
    case ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT:
      if (numberOfSelectedSessions === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedSessions > AppConstants.REPORT_MAXIMUM_SESSIONS_COUNT) {
        result.error = i18n.t('generateReport.warning.moreSessions');
      } else if (filteredSelectedTotalEngagementCount > AppConstants.REPORT_SHOW_INLINE_WARNING_COUNT) {
        const countMessage = i18n.t('generateReport.info.responseCountMessage', {
          selectedEngagementCount: filteredSelectedTotalEngagementCount,
          maxEngagementCount: AppConstants.REPORT_MAXIMUM_ENGAGEMENT_COUNT,
          totalEngagementCount: filteredTotalEngagementCount
        });
        if (filteredSelectedTotalEngagementCount > AppConstants.REPORT_MAXIMUM_ENGAGEMENT_COUNT) {
          result.error = countMessage;
        } else {
          result.subMessage = countMessage;
        }
      }
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      if (numberOfSelectedRecordings === 0) {
        result.error = i18n.t('generateReport.warning.noRecording');
      } else if (numberOfSelectedRecordings > 1) {
        result.error = i18n.t('generateReport.warning.oneRecording');
        result.moreInfoTooltip = i18n.t('generateReport.info.futureRecordingsMessage');
      }
      break;
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      if (numberOfSelectedWebinars === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedWebinars > 1) {
        result.error = i18n.t('generateReport.warning.oneWebinar');
        result.moreInfoTooltip = i18n.t('generateReport.info.futureWebinarsMessage');
      }
      break;
    case ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT:
      if (selectedVirtualEventTitle === '') {
        result.error = '';
      }
      break;
    case ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT:
      if (selectedVirtualEventTitle === '') {
        result.error = '';
      }
      break;
    default:
      console.warn('Invalid reportType selected');
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/Wizard/GenerateReportWizardUtils.js